import Box from '@mui/material/Box';

export type ChatMessageProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  isUserMessage: boolean;
  messageId: string;
  fullWidth?: boolean;
};

export function ChatMessage({ children, icon, isUserMessage, messageId, fullWidth = false }: ChatMessageProps) {
  return (
    <Box
      id={messageId}
      data-test={isUserMessage ? 'user-message' : 'agent-message'}
      sx={{
        alignSelf: isUserMessage ? 'flex-end' : 'flex-start',
        maxWidth: '85%',
        ...(fullWidth && { width: '85%' }),
        display: 'flex',
        flexDirection: isUserMessage ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
        gap: 1.25,
      }}
    >
      {icon}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          ...(fullWidth && { flex: 1, minWidth: 0 }),
          gap: 1,
          overflowWrap: 'break-word',
          overflow: 'auto',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          backgroundColor: isUserMessage ? theme => theme.palette.background.boxDarker : 'transparent',
          fontSize: 15,
          '& h2': { fontSize: 16 },
          '& h3': { fontSize: 15 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
